import React from "react";
import Geofence from "../../images/ic-placeholder-geofence.svg";
import { ListItem } from "./ListItem";
import styles from "./ListItems.css";

interface Props {
  address: null | string;
}

export const DestinyListItem = ({ address }: Props) => (
  <ListItem
    icon={<Geofence className={styles.icon} />}
    firstLine="Destino"
    secondLine={address || "Não é possível exibir o endereço neste momento."}
  />
);
